import React, { useEffect, useRef, useState } from "react";
import dropdownIcon from "../../assets/images/svg/dropdownIcon.svg";
// import withOthersNotSelected from "../../assets/images/svg/withOthersNotSelected.svg";
// import nuvamaSelected from "../../assets/images/svg/nuvamaSelected.svg";
// import withOtherSelected from "../../assets/images/svg/withOtherSelected.svg";
// import nuvamaNotSelected from "../../assets/images/svg/nuvamaNotSelected.svg";
import { getDecodedToken } from "../../utils/functions";
import ModalFamily from "../ModalFamily/ModalFamily";
import Modal from "../Modal";
import { observer } from "mobx-react";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ReportsStore from "../../store/ReportsStore";
import { OFFSHORE } from "../../utils/constants";
import { useNavigate } from "react-router";
import HoldingSelector from "./HoldingSelector";

const SelectNuvama = observer(
  ({
    type,
    handleWealth,
    handleClientSelection,
    selectedMember,
    setOpenFamilyModal = () => {},
    loader,
    memberDropdownClass = "",
    memberDropdownTextClass = "",
    downArrowIcon = dropdownIcon,
    onModalVisibilityChange = () => {},
    pointerEvent = false,
    disableToggle = false,
    page = "",
    isInvestmentHeldWithButtonDisabled = undefined,
  }) => {
    const withNuvama = UserStore.withNuvama;
    const withOthers = UserStore.withOthers;

    const navigate = useNavigate();

    const [isHeldaway, setIsHeldaway] = useState(null);
    const [selectedMem, setSelectedMember] = useState(selectedMember);

    const [modalOpen, setOpenFamilyModalLocal] = useState(false);
    const [isSort, setSort] = useState("asc");

    const familyModalRef = useRef(null);

    const getSelection = () => {
      let checkCondition = null;
      if (
        ((getDecodedToken()?.user_type === "employee" &&
          UserStore.userData?.isprimary) ||
          (getDecodedToken()?.user_type === "customer" &&
            UserStore.userData?.isprimary)) &&
        UserStore.getData === "fam"
      ) {
        checkCondition = UserStore?.userData?.isheldawayfamily;
      } else if (
        getDecodedToken()?.user_type === "manager" ||
        (getDecodedToken()?.user_type === "employee" &&
          !UserStore.userData?.isprimary) ||
        ((getDecodedToken()?.user_type === "customer" ||
          getDecodedToken()?.user_type === "employee") &&
          UserStore.userData?.isprimary) ||
        (getDecodedToken()?.user_type === "customer" &&
          !UserStore.userData?.isprimary)
      ) {
        checkCondition = UserStore?.userData?.isheldaway;
      }
      setIsHeldaway(checkCondition);
    };

    const getDefaultImage = (name) => {
      if (!name) return <></>;
      return (
        <div
          style={{
            backgroundColor: "#dde2eb",
          }}
          className="profileImageDefault2"
        >
          {name[0]}
        </div>
      );
    };

    const closeFamilyMemberModal = () => {
      setOpenFamilyModalLocal(false);
      onModalVisibilityChange(false);
      familyModalRef.current.focus();
    };

    useEffect(() => {}, [withNuvama, withOthers]);

    useEffect(() => {
      if (UserStore.isHydrated) getSelection();
    }, [UserStore.isHydrated, UserStore.userData.user_id]);

    const handleClick = (data = selectedMem) => {
      UserStore.setSelectedMemberIsPrimary(selectedMem?.isprimary);
      if (selectedMem === "0") {
        ReportsStore.updateReportsTodefault("check6");
        ReportsStore.updateCorporateFilterData(selectedMem);
        ReportsStore.updatePortfolioReportFilterData("All", "mod1");
      } else {
        ReportsStore.updatePortfolioReportFilterData(data, "mod2");
        ReportsStore.updateTransactionFilterData(data, "check");
        ReportsStore.updateCorporateFilterData(data);
      }

      if (page === "home") {
        let offshoreKey = null;
        if (data === "All") {
          const primaryMember = UserStore.currentFamilyMembers?.find(
            (user) => user.isprimary,
          );
          offshoreKey = primaryMember.isoffshorefamily;
        } else {
          offshoreKey = data.isoffshore;
        }
        if (offshoreKey === 1) {
          // navigate to portfolio and select global
          navigate("/portfolio", { state: { from: OFFSHORE } });
        }
      }
    };

    return (
      <div
        className="nuvama_selector_main"
        style={{ pointerEvents: pointerEvent ? "none" : "all" }}
      >
        {type !== "onlybtn" && (
          <>
            {/* <div
              style={{ cursor: "pointer" }}
              className="with_nuvama"
              onClick={() => {
                if (isHeldaway) {
                  UserStore.setAssetTabsData([]);
                  if (loader) {
                    window.scrollTo(0, 0);
                    AuthStore.updateLoadingFullScreen(true);
                  }
                  UserStore.setSelectWithNuvama("nuvama");
                  handleWealth("nuvama");
                }
              }}
              tabIndex={0}
            >
              <div className="logo2">
                <img
                  src={withNuvama ? nuvamaSelected : nuvamaNotSelected}
                  alt="With_nuvama"
                />
              </div>
              <div className="title2">Nuvama Private</div>
            </div>{" "} */}
            {/* <div
              style={{
                cursor: isHeldaway ? "pointer" : "not-allowed",
              }}
              className="without_nuvama"
              onClick={() => {
                if (isHeldaway) {
                  UserStore.setAssetTabsData([]);
                  if (loader) {
                    window.scrollTo(0, 0);
                    AuthStore.updateLoadingFullScreen(true);
                  }
                }}
              >
                <div className="logo2">
                  <img
                    src={withNuvama ? nuvamaSelected : nuvamaNotSelected}
                    alt="With_nuvama"
                  />
                </div>
                <div className="title2">Nuvama Private</div>
              </div>{" "}
              <div
                style={{
                  cursor: isHeldaway ? "pointer" : "not-allowed",
                }}
                className="without_nuvama"
                onClick={() => {
                  if (isHeldaway) {
                    UserStore.setAssetTabsData([]);
                    if (loader) {
                      window.scrollTo(0, 0);
                      AuthStore.updateLoadingFullScreen(true);
                    }
                    UserStore.setSelectWithNuvama("others", withOthers);
                    handleWealth("others");
                  }
                }}
              >
                {isHeldaway ? (
                  <img
                    src={withOthers ? withOtherSelected : withOthersNotSelected}
                    alt="with_others"
                  />
                ) : (
                  <img src={withOthersNotSelected} alt="With_others" />
                )}
              </div>
              <div className="title3">Others</div>
            </div>{" "} */}

            <HoldingSelector
              isHeldaway={isHeldaway}
              withNuvama={withNuvama}
              withOthers={withOthers}
              isSelectionDisabled={isInvestmentHeldWithButtonDisabled}
              handleChange={({ isNuvama }) => {
                UserStore.setAssetTabsData([]);
                if (loader) {
                  window.scrollTo(0, 0);
                  AuthStore.updateLoadingFullScreen(true);
                }

                if (isNuvama) {
                  UserStore.setSelectWithNuvama("nuvama");
                  handleWealth("nuvama");
                } else {
                  UserStore.setSelectWithNuvama("others", withOthers);
                  handleWealth("others");
                }
              }}
            />
          </>
        )}

        <button
          ref={familyModalRef}
          className={`members_dropdown ${memberDropdownClass}`}
          onClick={() => {
            if (
              UserStore.isPrimary &&
              getDecodedToken()?.user_type !== "manager"
            ) {
              setOpenFamilyModalLocal(true);
              onModalVisibilityChange(true);
            }
          }}
          tabIndex={0}
        >
          {getDecodedToken()?.user_type === "manager" ? (
            UserStore?.userData?.profile_pic && UserStore.singleUsersUrl ? (
              <img
                className="title_img"
                src={UserStore?.singleUsersUrl}
                alt=""
              />
            ) : (
              getDefaultImage(UserStore.userData?.full_name)
            )
          ) : !UserStore.userData.allMembers ? (
            UserStore?.userData?.profile_pic &&
            UserStore.currentFamilyMembersImages?.[
              UserStore?.userData?.user_id
            ] ? (
              <img
                className="title_img"
                src={
                  UserStore.currentFamilyMembersImages?.[
                    UserStore?.userData?.user_id
                  ]
                }
                alt=""
              />
            ) : (
              getDefaultImage(UserStore.userData?.full_name)
            )
          ) : (
            ""
          )}
          {UserStore.userData.allMembers ? (
            <span
              className={`${
                !UserStore.userData.allMembers
                  ? "dropdown_title dropdown_padding_img"
                  : "dropdown_title dropdown_padding_without_img"
              } ${memberDropdownTextClass}`}
            >
              All Members
            </span>
          ) : (
            <marquee
              className={`${
                !UserStore.userData.allMembers
                  ? "dropdown_title dropdown_padding_img"
                  : "dropdown_title dropdown_padding_without_img"
              } ${memberDropdownTextClass}`}
              scrollamount={2}
            >
              {UserStore.userData.allMembers
                ? "All Member"
                : UserStore.userData?.full_name}
            </marquee>
          )}

          {UserStore.isPrimary &&
            getDecodedToken()?.user_type !== "manager" && (
              <img
                aria-hidden={true}
                className="arrow_img"
                src={downArrowIcon}
                alt="dropdown"
                style={{}}
              />
            )}
        </button>
        <Modal
          onClose={closeFamilyMemberModal}
          open={modalOpen}
          title={"Select Family Member"}
          width={"810px"}
          modalStyle={{
            overflow: "auto",
          }}
          //dialogId={"select-family-member"}
          announcement={"select-family-member"}
        >
          <ModalFamily
            isSort={isSort}
            setSort={setSort}
            open={modalOpen}
            onClose={closeFamilyMemberModal}
            handleWealth={(title) => {
              UserStore.setAssetTabsData([]);
              handleWealth(title);
            }}
            setSelectedMemberForReports={(id) => {
              setSelectedMember(id);
            }}
            onClickApply={() => handleClick()}
          />
        </Modal>
      </div>
    );
  },
);

export default SelectNuvama;
